<div class="informacion-negocio-step">
  <ng-container *ngIf="!completado">
  <p class="main-question"><strong>Información del negocio</strong></p>
  <p class="subtext">
    Con esto entendemos a qué se dedica la empresa y de dónde provienen sus fondos.
  </p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-wrapper">
    <!-- Actividad -->
    <div class="section-divider"><span>Actividad</span></div>

    <div class="floating-group">
      <textarea
        id="in_descripcion"
        formControlName="descripcionNegocio"
        rows="3"
        [maxlength]="maxDescripcion"
      ></textarea>
      <label for="in_descripcion">Breve descripción del negocio</label>
    </div>
    <p class="char-count" [class.warn]="charsLeft('descripcionNegocio') < 50">
      {{ charsLeft('descripcionNegocio') }} caracteres disponibles
    </p>
    <p class="field-error" *ngIf="isFieldInvalid('descripcionNegocio')">
      Describe brevemente a qué se dedica la empresa.
    </p>

    <div class="floating-group">
      <select id="in_actividad" formControlName="actividadEconomica">
        <option value="" disabled hidden></option>
        <option *ngFor="let actividad of actividades" [value]="actividad.value">
          {{ actividad.label }}
        </option>
      </select>
      <label for="in_actividad">Actividad económica ante el S.I.I.</label>
    </div>
    <p class="field-error" *ngIf="isFieldInvalid('actividadEconomica')">
      Selecciona la actividad económica.
    </p>
    <!-- La glosa del e-RUT es texto libre del SII y esta lista es cerrada, así
         que no se puede preseleccionar sin adivinar: se muestra para que el
         usuario elija sin tener que ir a buscar su e-RUT. -->
    <p class="field-hint" *ngIf="signupState.erutAnalysis?.glosaActividad">
      En tu e-RUT figura como
      «{{ signupState.erutAnalysis?.glosaActividad }}». Elige la opción que más
      se le acerque.
    </p>

    <!-- Origen de fondos -->
    <div class="section-divider"><span>Origen de fondos</span></div>

    <div class="floating-group">
      <select id="in_origen" formControlName="origenFondos">
        <option value="" disabled hidden></option>
        <option *ngFor="let origen of origenFondos" [value]="origen.value">
          {{ origen.label }}
        </option>
      </select>
      <label for="in_origen">Origen de fondos</label>
    </div>
    <p class="field-error" *ngIf="isFieldInvalid('origenFondos')">
      Selecciona el origen de los fondos.
    </p>

    <div class="floating-group">
      <textarea
        id="in_descripcion_origen"
        formControlName="descripcionOrigenFondos"
        rows="3"
        [maxlength]="maxDescripcion"
      ></textarea>
      <label for="in_descripcion_origen">Descripción del origen de fondos</label>
    </div>
    <p class="char-count" [class.warn]="charsLeft('descripcionOrigenFondos') < 50">
      {{ charsLeft('descripcionOrigenFondos') }} caracteres disponibles
    </p>
    <p class="field-error" *ngIf="isFieldInvalid('descripcionOrigenFondos')">
      Explica de dónde provienen los fondos de la empresa.
    </p>

    <!-- Situación patrimonial -->
    <div class="section-divider"><span>Situación patrimonial</span></div>

    <div class="floating-group">
      <select id="in_ingresos" formControlName="ingresosMensuales">
        <option value="" disabled hidden></option>
        <option *ngFor="let rango of ingresosMensuales" [value]="rango.value">
          {{ rango.label }}
        </option>
      </select>
      <label for="in_ingresos">Ingresos mensuales (USD)</label>
    </div>

    <div class="form-grid">
      <div class="floating-group">
        <select id="in_patrimonio_total" formControlName="patrimonioTotal">
          <option value="" disabled hidden></option>
          <option *ngFor="let rango of patrimonio" [value]="rango.value">
            {{ rango.label }}
          </option>
        </select>
        <label for="in_patrimonio_total">Patrimonio total (USD)</label>
      </div>
      <div class="floating-group">
        <select id="in_patrimonio_fin" formControlName="patrimonioFinanciero">
          <option value="" disabled hidden></option>
          <option *ngFor="let rango of patrimonio" [value]="rango.value">
            {{ rango.label }}
          </option>
        </select>
        <label for="in_patrimonio_fin">Patrimonio financiero (USD)</label>
      </div>
    </div>

    <p class="field-error" *ngIf="isFieldInvalid('ingresosMensuales') || isFieldInvalid('patrimonioTotal') || isFieldInvalid('patrimonioFinanciero')">
      Selecciona los ingresos y el patrimonio.
    </p>

    <!-- Operaciones -->
    <div class="section-divider"><span>Operaciones esperadas</span></div>

    <div class="form-grid">
      <div class="floating-group">
        <select id="in_cantidad_ops" formControlName="cantidadOperacionesMensuales">
          <option value="" disabled hidden></option>
          <option *ngFor="let cantidad of cantidadOperaciones" [value]="cantidad.value">
            {{ cantidad.label }}
          </option>
        </select>
        <label for="in_cantidad_ops">Cantidad de operaciones al mes</label>
      </div>
      <div class="floating-group">
        <input
          type="text"
          id="in_volumen_ops"
          formControlName="volumenOperacionesMensuales"
          inputmode="numeric"
          (keydown)="allowOnlyNumbers($event)"
        />
        <label for="in_volumen_ops">Volumen mensual (USD)</label>
      </div>
    </div>

    <p class="field-error" *ngIf="isFieldInvalid('cantidadOperacionesMensuales') || isFieldInvalid('volumenOperacionesMensuales')">
      Indica la cantidad y el volumen de operaciones esperadas.
    </p>

    <!-- Acciones -->
    <div class="actions">
      <button type="submit" class="continue-btn" [disabled]="loading">
        {{ loading ? 'Guardando...' : 'Guardar y continuar' }}
      </button>
      <button type="button" class="back-btn" (click)="goBack()" [disabled]="loading">
        Volver
      </button>
    </div>
  </form>
  </ng-container>

  <!-- ==================== CIERRE DEL PRE-REGISTRO ====================
       El pre-registro deja `estado_compliance_id` en 0 pero crea el cupo
       (tabla `cupo_registro`): el usuario queda PRE-operativo y puede operar
       dentro del tope mientras completa la documentación de la sociedad. -->
  <ng-container *ngIf="completado">
    <div class="done-card">
      <mat-icon class="done-icon">check_circle</mat-icon>
      <p class="main-question"><strong>¡Tu acceso fue preaprobado!</strong></p>
      <p class="subtext">
        Con los datos que nos proporcionaste y la verificación de tu
        identidad, ya puedes ingresar a Aguacate Wallet y comenzar a operar
        con un límite preaprobado.
      </p>

      <!-- Caja del límite preaprobado -->
      <div class="preaprobado-box">
        <mat-icon class="preaprobado-box__icon">savings</mat-icon>
        <div class="preaprobado-box__text">
          <span class="preaprobado-box__label">Ya puedes operar hasta</span>
          <span class="preaprobado-box__amount">$14.000.000 CLP</span>
          <span class="preaprobado-box__hint">
            mientras completas la documentación de tu empresa.
          </span>
        </div>
      </div>

      <ul class="done-list">
        <li>Puedes comenzar a operar desde ahora.</li>
        <li>Podrás completar la documentación desde tu cuenta cuando quieras.</li>
        <li>
          Una vez enviada, nuestro equipo de Cumplimiento la revisará y te
          avisaremos por correo.
        </li>
      </ul>

      <div class="actions">
        <button type="button" class="continue-btn" (click)="entrarAlDashboard()">
          Entrar a mi cuenta
        </button>
      </div>
    </div>
  </ng-container>
</div>
